import RestrictionsView from './RestrictionsView';

export default RestrictionsView;